__webpack_require__.p = "/deactivate-children-guard/referrals/";